import * as React from "react";
import { toINR } from "../../../../service/numberFormat";
import SlideUpPopup from "../../../../generic/slideUpPopup";
import HoldEqUsablePopup from "./holdEqUsablePopup";

export interface IHoldEqUsableRowMobProps {
	rowData: any;
}

const HoldEqUsableRowMob: React.FC<IHoldEqUsableRowMobProps> = props => {
	const [isPopupOpen, setIsPopupOpen] = React.useState(false);

	return (
		<>
			<li className="data_row" onClick={() => setIsPopupOpen(true)}>
				<div className="row1">
					<div className="col trdSym">
						<span dangerouslySetInnerHTML={{ __html: props.rowData.trdSym }}></span>
					</div>
					<div className="col ltp">LTP: ₹{toINR(props.rowData.ltp, 2)}</div>
				</div>
				<div className="row2">
					<div className="col totQty">Total Qty: {props.rowData.cncRmsHdg ? toINR(props.rowData.cncRmsHdg.totQty) : "—"}</div>
					<div className="col totQty">{props.rowData.mtfRmsHdg && "MTF Qty: " + toINR(props.rowData.mtfRmsHdg.totQty)}</div>
				</div>
			</li>

			{isPopupOpen && (
				<SlideUpPopup closePopup={() => setIsPopupOpen(false)}>
					<HoldEqUsablePopup data={props.rowData} onClose={() => setIsPopupOpen(false)} />
				</SlideUpPopup>
			)}
		</>
	);
};

export default HoldEqUsableRowMob;
